






































































































import Vue from "vue";
import loginService from "@/global/service/login";
import basicService from "@/global/service/basic";
import TheLayoutFooter from "@/components/TheLayoutFooter.vue";
import SidePart from "@/components/SidePart.vue";
import { message } from "ant-design-vue";
import { CountDown } from "@/utils/countDown";
const countDown = new CountDown();
interface FormState {
  contacts_phone: string;
  code: string;
  industry_type: number;
}
export default Vue.extend({
  components: { TheLayoutFooter, SidePart },
  data(): {
    form: FormState;
    formRules: SquareConfig;
    buttonName: string;
    time: number;
    isDisabled: boolean;
    isActive: boolean;
    btnLoading: boolean;
    loginActive: boolean;
  } {
    return {
      form: {
        contacts_phone: "",
        code: "",
        industry_type: 1,
      },
      formRules: {
        industry_name: [
          {
            required: true,
            message: "机构名称不能为空",
            trigger: ["blur", "change"],
          },
        ],
        contacts_name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: ["blur", "change"],
          },
        ],
        contacts_phone: [
          {
            required: true,
            validator: this.checkPhone,
            trigger: ["blur", "change"],
          },
        ],
        code: [
          {
            required: true,
            validator: this.checkCode,
            trigger: ["blur", "change"],
          },
        ],
        contacts_position: [
          {
            required: true,
            message: "职位不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      buttonName: "获取验证码",
      time: 60,
      isDisabled: false,
      btnLoading: false,
      isActive: false,
      loginActive: false,
    };
  },
  computed: {
    selectTypeName() {
      return ["公司", "院校", "机构"][this.form.industry_type - 1];
    },
  },
  created() {},
  methods: {
    checkPhone(rule: any, value: string, cb: Function) {
      if (!value) {
        cb("联系方式不能为空");
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        cb("格式不正确");
      } else {
        cb();
      }
    },
    checkCode(rule: any, value: string, cb: Function) {
      if (!value) {
        cb("请输入验证码");
      } else if (value.trim().length !== 6) {
        cb("请输入六位验证码");
      } else {
        cb();
      }
    },
    getCode() {
      (this.$refs["formApply"] as Vue).validateField(
        "contacts_phone",
        (valid: any) => {
          if (!valid) {
            loginService.smsSend({ telephone: this.form.contacts_phone });
            this.isDisabled = true;
            this.isActive = true;
            this.isActive = true;
            this.isDisabled = true;
            this.buttonName = this.time + "秒后重新发送";
            countDown.listen = ({ time = 0, status }: SquareConfig) => {
              if (status === "end") {
                this.buttonName = "获取验证码";
                this.time = 60;
                this.isActive = false;
                this.isDisabled = false;
                return;
              }
              this.time = time;
              const duration = Math.ceil(time / 1000) || 0;
              this.buttonName = duration + "秒后重新发送";
            };
            this.endTime = Date.now() + 1 * 60 * 1000;
            countDown.start(this.time * 1000, this.endTime);
          }
        }
      );
    },
    handleTrial() {
      (this.$refs["formApply"] as Vue).validate((valid: boolean) => {
        if (valid) {
          basicService.trialHandle(this.form).then(() => {
            message.success("提交成功");
            this.$router.push({ name: "HomePage" });
          });
        }
      });
    },
  },
});
